import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// Applets pc App
export default  new Vuex.Store({
  state: {
    count: 0,
    indexC:0,
    count1:0
  },
  getters:{
    doneTodos:state=>{
      return state.count
    },
    doneTodos2:state=>{
      return state.count1
    },
    indexCGT:state=>{
      return state.indexC
    }
  },
  mutations: {
    increment (state,str) {
      state.count  = str
      setTimeout(()=>{
        state.count  = 0
      },500)
    },
    increment2 (state,str) {
      state.count1  = str
      setTimeout(()=>{
        state.count1 = 0
      },500)
    },
    increment1 (state,str) {
      state.indexC  = str
      setTimeout(()=>{
        state.indexC  = 0
      },500)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js